import React from 'react'
import { Link } from "gatsby";

const BreadCrumbs = ({title}) => {
  return (
    <div>
        <div className='flex gap-2 bg-white text-dorot-purple font-semibold lg:pl-18 font-goldplay text-_1225 lg:pt-4 lg:pb-3'>
            <span><Link to='/'>Home</Link></span>
            <span>/</span>
            <span><Link to='/recipes'>Recipes</Link></span>
            <span>/</span>
            <span>{title}</span>
        </div>
    </div>
  )
}

export default BreadCrumbs